import React from "react";
import LegalPage from "./LegalPage";

export default function TerminosPage() {
  return (
    <LegalPage
      title="Términos y Condiciones de Servicio"
      subtitle="Términos y Condiciones · Yarima Rodriguez"
      lastUpdated="15 de diciembre de 2025"
    >
      <p><strong>Fecha de entrada en vigor:</strong> 15 de diciembre de 2025</p>

      <h2>1. INFORMACIÓN GENERAL Y ACEPTACIÓN</h2>
      <h3>1.1 Identificación del Prestador del Servicio</h3>
      <ul>
        <li><strong>Razón Social:</strong> Yarima Rodriguez Valenciano</li>
        <li><strong>Domicilio Fiscal:</strong> Via Vittorio Alfieri 18, San Benedetto del Tronto (AP), Italia</li>
        <li><strong>Correo Electrónico:</strong> <a href="mailto:contacto@yarimarodriguez.com">contacto@yarimarodriguez.com</a></li>
        <li><strong>Sitio Web:</strong> <a href="https://www.yarimarodriguez.com" target="_blank" rel="noreferrer">https://www.yarimarodriguez.com</a></li>
        <li><strong>Partita IVA:</strong> 02555260443</li>
      </ul>

      <h3>1.2 Aceptación de los Términos</h3>
      <p>Al acceder, navegar o utilizar nuestros servicios de clases y cursos de baile online ("Servicios"), aceptas quedar vinculado por estos Términos y Condiciones ("Términos").</p>
      <p>Si no estás de acuerdo con alguna parte de estos términos, no debes utilizar nuestros Servicios.</p>
      <p>Estos Términos constituyen un contrato legalmente vinculante entre tú ("Usuario", "Alumno" o "Tú") y Yarima Rodriguez Valenciano ("nosotros", "nos" o "la Empresa").</p>

      <h3>1.3 Capacidad Legal y Edad Mínima</h3>
      <p><strong>REQUISITO DE EDAD:</strong> Debes tener al menos 21 años para utilizar nuestros Servicios. Al registrarte, declaras y garantizas que:</p>
      <ul>
        <li>Tienes al menos 21 años de edad</li>
        <li>Posees la capacidad legal para celebrar contratos vinculantes</li>
        <li>Toda la información proporcionada es verdadera, precisa y completa</li>
      </ul>

      <h2>2. DESCRIPCIÓN DE LOS SERVICIOS</h2>
      <h3>2.1 Servicios Ofrecidos</h3>
      <p>Ofrecemos:</p>
      <ul>
        <li><strong>Clases de baile online en vivo:</strong> Sesiones interactivas en tiempo real</li>
        <li><strong>Cursos pregrabados:</strong> Contenido educativo de baile accesible bajo demanda</li>
        <li><strong>Material complementario:</strong> Recursos descargables, guías y música</li>
        <li><strong>Asesoría personalizada:</strong> Sesiones individuales o grupales (servicio premium)</li>
      </ul>

      <h3>2.2 Modalidades de Servicio</h3>
      <ul>
        <li><strong>Conexión a internet estable</strong> (mínimo 5 Mbps recomendado)</li>
        <li><strong>Paquetes de clases:</strong> Bonos de múltiples sesiones con descuento</li>
        <li><strong>Suscripciones mensuales:</strong> Acceso ilimitado a contenido específico</li>
        <li><strong>Cursos completos:</strong> Programas estructurados con duración determinada</li>
      </ul>

      <h3>2.3 Requisitos Técnicos</h3>
      <p>El Usuario es responsable de contar con:</p>
      <ul>
        <li>Conexión a internet estable (mínimo 5 Mbps recomendado)</li>
        <li>Dispositivo compatible (computadora, tablet o smartphone)</li>
        <li>Software necesario (navegador actualizado, aplicación de videoconferencia)</li>
        <li>Espacio físico adecuado y seguro para la práctica</li>
      </ul>

      <h2>3. REGISTRO Y CUENTA DE USUARIO</h2>
      <h3>3.1 Proceso de Registro</h3>
      <p>Para acceder a los Servicios debes:</p>
      <ul>
        <li>Completar el formulario de registro con información veraz</li>
        <li>Verificar tu dirección de correo electrónico</li>
        <li>Confirmar que tienes al menos 21 años</li>
        <li>Aceptar estos Términos y la Política de Privacidad</li>
      </ul>

      <h3>3.2 Seguridad de la Cuenta</h3>
      <p>Eres responsable de:</p>
      <ul>
        <li>Mantener la confidencialidad de tus credenciales</li>
        <li>Todas las actividades realizadas bajo tu cuenta</li>
        <li>Notificar inmediatamente cualquier uso no autorizado</li>
        <li>No compartir tu cuenta con terceros</li>
      </ul>

      <h3>3.3 Veracidad de la Información</h3>
      <p>Te comprometes a:</p>
      <ul>
        <li>Proporcionar información verdadera y actualizada</li>
        <li>Mantener tu información de perfil al día</li>
        <li>No crear cuentas falsas o múltiples</li>
        <li>Cumplir con los requisitos de verificación cuando se soliciten</li>
      </ul>

      <h2>4. CONDICIONES ECONÓMICAS</h2>
      <h3>4.1 Precios y Tarifas</h3>
      <ul>
        <li>Todos los precios se muestran en EUROS (€) e incluyen IVA cuando aplique</li>
        <li>Los precios para usuarios de Latinoamérica pueden mostrarse en USD o moneda local</li>
        <li>Los precios están sujetos a cambios con previo aviso de 30 días</li>
        <li>Las promociones y descuentos tienen condiciones específicas</li>
      </ul>

      <h3>4.2 Métodos de Pago</h3>
      <p>Aceptamos:</p>
      <ul>
        <li>Tarjetas de crédito/débito (Visa, Mastercard, American Express)</li>
        <li>PayPal</li>
        <li>Transferencias bancarias SEPA (Europa)</li>
        <li>Plataformas de pago regional (según disponibilidad)</li>
      </ul>

      <h3>4.3 Facturación</h3>
      <ul>
        <li>Las facturas se emiten electrónicamente conforme a la normativa fiscal italiana y europea</li>
        <li>Para usuarios empresariales: proporcionar datos fiscales completos</li>
        <li>Retención de documentos fiscales: 10 años según normativa</li>
      </ul>

      <h3>4.4 Política de Reembolsos</h3>
      <p><strong>Derecho de Desistimiento (Consumidores UE):</strong></p>
      <ul>
        <li>14 días naturales desde la contratación para servicios no iniciados</li>
        <li>Sin necesidad de justificación</li>
        <li>Reembolso completo en 14 días desde la notificación</li>
      </ul>
      <p><strong>Cancelaciones y Reembolsos:</strong></p>
      <ul>
        <li>Clases individuales: Cancelación gratuita hasta 24 horas antes</li>
        <li>Suscripciones: Prorrateo del período no utilizado</li>
        <li>Cursos iniciados: Sin reembolso salvo causa justificada</li>
        <li>Problemas técnicos atribuibles a nosotros: Reembolso o reprogramación</li>
      </ul>

      <h2>5. DERECHOS DE PROPIEDAD INTELECTUAL</h2>
      <h3>5.1 Propiedad del Contenido</h3>
      <p>Todos los derechos sobre:</p>
      <ul>
        <li>Coreografías y secuencias de movimientos</li>
        <li>Videos, música y material audiovisual</li>
        <li>Metodología de enseñanza</li>
        <li>Marcas, logos y elementos distintivos</li>
        <li>Material didáctico y documentación</li>
      </ul>
      <p>Son propiedad exclusiva de Yarima Rodriguez Valenciano o sus licenciantes.</p>

      <h3>5.2 Licencia de Uso</h3>
      <p>Se te otorga una licencia:</p>
      <ul>
        <li>Personal, no exclusiva e intransferible</li>
        <li>Para uso privado y no comercial</li>
        <li>Revocable en caso de incumplimiento</li>
        <li>Limitada a la duración de tu suscripción o curso</li>
      </ul>

      <h3>5.3 Restricciones</h3>
      <p>Está estrictamente prohibido:</p>
      <ul>
        <li>Grabar, reproducir o distribuir las clases sin autorización</li>
        <li>Usar el contenido con fines comerciales</li>
        <li>Modificar, adaptar o crear obras derivadas</li>
        <li>Compartir credenciales o material con terceros</li>
        <li>Realizar ingeniería inversa de la plataforma</li>
      </ul>

      <h3>5.4 Contenido del Usuario</h3>
      <p>Si compartes contenido (videos de práctica, comentarios):</p>
      <ul>
        <li>Conservas tus derechos pero nos otorgas licencia de uso</li>
        <li>Garantizas que no infringe derechos de terceros</li>
        <li>Nos autorizas a usarlo con fines promocionales (con tu consentimiento)</li>
      </ul>

      <h2>6. NORMAS DE CONDUCTA Y USO ACEPTABLE</h2>
      <h3>6.1 Conducta Esperada</h3>
      <p>Los usuarios deben:</p>
      <ul>
        <li>Mantener un comportamiento respetuoso y profesional</li>
        <li>Vestir apropiadamente durante las clases en vivo</li>
        <li>Respetar la diversidad cultural y personal</li>
        <li>Seguir las instrucciones de seguridad</li>
      </ul>

      <h3>6.2 Prohibiciones</h3>
      <p>Está prohibido:</p>
      <ul>
        <li>Acosar, intimidar o discriminar a otros usuarios o instructores</li>
        <li>Compartir contenido inapropiado o ilegal</li>
        <li>Interrumpir deliberadamente las clases</li>
        <li>Hacer uso comercial no autorizado de los servicios</li>
        <li>Intentar acceder a áreas restringidas del sistema</li>
      </ul>

      <h3>6.3 Medidas Disciplinarias</h3>
      <p>El incumplimiento puede resultar en:</p>
      <ul>
        <li>Advertencia formal</li>
        <li>Suspensión temporal del acceso</li>
        <li>Terminación permanente de la cuenta</li>
        <li>Acciones legales cuando corresponda</li>
      </ul>

      <h2>7. LIMITACIÓN DE RESPONSABILIDAD</h2>
      <h3>7.1 Exención de Responsabilidad</h3>
      <p><strong>IMPORTANTE - ASUNCIÓN DE RIESGOS FÍSICOS:</strong></p>
      <ul>
        <li>La práctica de baile conlleva riesgos físicos inherentes</li>
        <li>Debes consultar a un médico antes de iniciar cualquier programa de ejercicio</li>
        <li>Eres responsable de tu seguridad y bienestar durante las clases</li>
        <li>Recomendamos contratar un seguro de accidentes personal</li>
      </ul>

      <h3>7.2 EXENCIÓN DE RESPONSABILIDAD MÉDICA - INFORMACIÓN DE SALUD Y BIENESTAR</h3>
      <p><strong>AVISO IMPORTANTE SOBRE INFORMACIÓN DE SALUD:</strong></p>
      <p>Durante nuestras clases, cursos y servicios, podemos proporcionar información general sobre:</p>
      <ul>
        <li>Beneficios del baile y el ejercicio físico</li>
        <li>Bienestar general y calidad de vida</li>
        <li>Aspectos relacionados con el movimiento corporal y la actividad física</li>
        <li>Recomendaciones generales de estilo de vida saludable</li>
      </ul>
      <p><strong>DECLARACIÓN EXPRESA DE NO RESPONSABILIDAD MÉDICA:</strong></p>
      <ol>
        <li><strong>NO ES CONSEJO MÉDICO:</strong> Cualquier información compartida sobre beneficios del baile, ejercicio, salud o bienestar es únicamente para fines informativos y educativos generales. NO constituye consejo médico, diagnóstico, tratamiento o recomendación médica profesional.</li>
        <li><strong>NO SOMOS PROFESIONALES MÉDICOS:</strong> Los instructores y personal de Yarima Rodriguez Valenciano no son médicos, fisioterapeutas, nutricionistas licenciados ni profesionales de la salud certificados, salvo que se especifique expresamente lo contrario.</li>
        <li><strong>CONSULTA MÉDICA OBLIGATORIA:</strong> Antes de comenzar cualquier programa de ejercicio o baile, debes:
          <ul>
            <li>Consultar con tu médico de cabecera</li>
            <li>Obtener autorización médica si tienes condiciones preexistentes</li>
            <li>Informar sobre cualquier limitación física o médica</li>
            <li>Seguir las recomendaciones de tu profesional de la salud</li>
          </ul>
        </li>
        <li><strong>NO REEMPLAZA ATENCIÓN MÉDICA:</strong> Nuestros servicios NO reemplazan el consejo médico profesional, diagnóstico o tratamiento. Siempre busca la opinión de tu médico u otro profesional de la salud calificado ante cualquier pregunta sobre tu condición médica.</li>
        <li><strong>RESPONSABILIDAD DEL USUARIO:</strong> Al participar en nuestras clases, aceptas que:
          <ul>
            <li>Participas bajo tu propio riesgo</li>
            <li>Eres responsable de conocer tus limitaciones físicas</li>
            <li>No nos responsabilizas por consecuencias derivadas de seguir información general sobre bienestar</li>
            <li>Cualquier decisión relacionada con tu salud debe ser consultada con profesionales médicos</li>
          </ul>
        </li>
      </ol>
      <p><strong>CONDICIONES MÉDICAS ESPECÍFICAS:</strong> Si tienes alguna de las siguientes condiciones, debes obtener autorización médica antes de participar:</p>
      <ul>
        <li>Problemas cardiovasculares</li>
        <li>Lesiones previas o problemas articulares</li>
        <li>Embarazo</li>
        <li>Condiciones médicas crónicas</li>
        <li>Cualquier limitación física</li>
      </ul>

      <h3>7.3 Limitaciones Generales</h3>
      <p>NO seremos responsables por:</p>
      <ul>
        <li>Lesiones físicas derivadas de la práctica</li>
        <li>Pérdidas indirectas, consecuenciales o punitivas</li>
        <li>Interrupciones del servicio por causas ajenas</li>
        <li>Incompatibilidades técnicas en tu equipo</li>
        <li>Pérdida de datos o contenido del usuario</li>
        <li>Consecuencias derivadas de malinterpretar información general sobre bienestar como consejo médico</li>
      </ul>

      <h3>7.4 Límite Máximo de Responsabilidad</h3>
      <p>Nuestra responsabilidad total no excederá el monto pagado por ti en los últimos 12 meses o 100€, lo que sea menor.</p>

      <h3>7.5 Indemnización</h3>
      <p>Aceptas indemnizarnos y mantenernos indemnes frente a reclamaciones derivadas de:</p>
      <ul>
        <li>Tu incumplimiento de estos Términos</li>
        <li>Tu uso negligente o inadecuado de los Servicios</li>
        <li>Violación de derechos de terceros</li>
        <li>Incumplimiento de leyes aplicables</li>
        <li>Lesiones o daños resultantes de no seguir las recomendaciones médicas apropiadas</li>
      </ul>

      <h2>8. PRIVACIDAD Y PROTECCIÓN DE DATOS</h2>
      <h3>8.1 Cumplimiento Normativo</h3>
      <p>Cumplimos con:</p>
      <ul>
        <li>Reglamento General de Protección de Datos (GDPR) UE 2016/679</li>
        <li>Ley Italiana de Protección de Datos</li>
        <li>Normativas de protección de datos aplicables en Latinoamérica</li>
      </ul>

      <h3>8.2 Tratamiento de Datos</h3>
      <ul>
        <li>Los datos se procesan según nuestra Política de Privacidad</li>
        <li>Bases legales: consentimiento y ejecución contractual</li>
        <li>Derechos ARCO/GDPR garantizados</li>
        <li>Transferencias internacionales con salvaguardas adecuadas</li>
      </ul>

      <h3>8.3 USO DE IMAGEN Y GRABACIONES CON FINES PROMOCIONALES</h3>
      <p><strong>POLÍTICA OBLIGATORIA SOBRE USO DE IMAGEN:</strong></p>

      <h3>8.3.1 Consentimiento para Uso Promocional</h3>
      <p>Al participar en nuestras clases, cursos, eventos o cualquier actividad relacionada con nuestros servicios, declaras expresamente que:</p>
      <ol>
        <li><strong>CONSIENTES EL USO PROMOCIONAL:</strong> Autorizas a Yarima Rodriguez Valenciano a utilizar tu imagen, voz, nombre y likeness (semejanza) capturados durante:
          <ul>
            <li>Clases en vivo online</li>
            <li>Eventos presenciales o virtuales</li>
            <li>Sesiones de práctica</li>
            <li>Testimonios o entrevistas</li>
            <li>Cualquier actividad relacionada con nuestros servicios</li>
          </ul>
        </li>
        <li><strong>FINES PROMOCIONALES INCLUYEN:</strong>
          <ul>
            <li>Publicaciones en redes sociales (Instagram, Facebook, TikTok, YouTube, etc.)</li>
            <li>Material publicitario y promocional</li>
            <li>Sitio web oficial y páginas de marketing</li>
            <li>Testimonios y casos de éxito</li>
            <li>Contenido educativo y demostrativo</li>
            <li>Presentaciones comerciales</li>
          </ul>
        </li>
      </ol>

      <h3>8.3.2 CONDICIÓN OBLIGATORIA DE PARTICIPACIÓN</h3>
      <p><strong>AVISO IMPORTANTE:</strong></p>
      <ul>
        <li>Si NO deseas aparecer en material promocional o en redes sociales, NO puedes participar en nuestras clases, eventos o actividades.</li>
        <li>La participación en cualquier servicio implica automáticamente tu consentimiento para uso promocional.</li>
        <li>No ofrecemos opciones de participación sin consentimiento de imagen.</li>
      </ul>

      <h3>8.3.3 Alcance del Consentimiento</h3>
      <p>Tu consentimiento incluye específicamente:</p>
      <ol>
        <li><strong>GRABACIÓN Y CAPTURA:</strong>
          <ul>
            <li>Fotografías y videos durante las clases</li>
            <li>Capturas de pantalla de sesiones online</li>
            <li>Grabaciones de audio y video completas</li>
            <li>Material de "behind the scenes"</li>
          </ul>
        </li>
        <li><strong>USO Y DISTRIBUCIÓN:</strong>
          <ul>
            <li>Publicación en todas las redes sociales sin limitación geográfica</li>
            <li>Uso en campañas publicitarias pagadas</li>
            <li>Inclusión en material impreso y digital</li>
            <li>Distribución a medios de comunicación</li>
            <li>Uso en presentaciones comerciales y educativas</li>
          </ul>
        </li>
        <li><strong>DURACIÓN Y TERRITORIO:</strong>
          <ul>
            <li><strong>Duración:</strong> Indefinida (hasta que solicites la revocación)</li>
            <li><strong>Territorio:</strong> Mundial, sin restricciones geográficas</li>
            <li><strong>Medios:</strong> Todos los medios conocidos y por conocer</li>
          </ul>
        </li>
      </ol>

      <h3>8.3.4 Derechos del Usuario sobre su Imagen</h3>
      <p><strong>DERECHOS QUE CONSERVAS:</strong></p>
      <ol>
        <li><strong>Derecho de Información:</strong> Conocer dónde y cómo se usa tu imagen</li>
        <li><strong>Derecho de Acceso:</strong> Solicitar copias del material donde apareces</li>
        <li><strong>Derecho de Supresión:</strong> Solicitar la eliminación de material específico (con limitaciones)</li>
        <li><strong>Derecho de Oposición:</strong> Oponerte a usos futuros (puede resultar en exclusión de servicios)</li>
      </ol>
      <p><strong>LIMITACIONES DE TUS DERECHOS:</strong></p>
      <ul>
        <li>No puedes solicitar la eliminación de material ya publicado si afecta la integridad de contenido educativo</li>
        <li>No puedes exigir compensación económica por el uso de tu imagen</li>
        <li>No puedes restringir el uso una vez otorgado el consentimiento durante la clase</li>
      </ul>

      <h3>8.3.5 CONSENTIMIENTO ESPECÍFICO Y REVOCACIÓN</h3>
      <p><strong>OTORGAMIENTO DE CONSENTIMIENTO:</strong> Al participar en cualquier clase o evento, automáticamente:</p>
      <ul>
        <li>Otorgas consentimiento libre, específico, informado e inequívoco</li>
        <li>Reconoces haber leído y comprendido esta política</li>
        <li>Aceptas las condiciones de uso de imagen establecidas</li>
      </ul>
      <p><strong>REVOCACIÓN DEL CONSENTIMIENTO:</strong></p>
      <ul>
        <li>Puedes revocar tu consentimiento en cualquier momento</li>
        <li>La revocación debe ser por escrito a: <a href="mailto:contacto@yarimarodriguez.com">contacto@yarimarodriguez.com</a></li>
        <li><strong>IMPORTANTE:</strong> La revocación implica la exclusión automática de todos los servicios futuros</li>
        <li>Material ya publicado puede mantenerse según el interés legítimo de la empresa</li>
      </ul>

      <h3>8.3.6 Menores de Edad y Consideraciones Especiales</h3>
      <ul>
        <li>Dado que nuestros servicios son exclusivamente para mayores de 21 años, no aplicamos políticas especiales de menores</li>
        <li>Sin embargo, mantenemos especial cuidado en el tratamiento respetuoso de la imagen</li>
        <li>Todo material se usa con fines profesionales y educativos</li>
      </ul>

      <h3>8.3.7 CONSECUENCIAS DE LA NEGATIVA</h3>
      <p><strong>SI NO ACEPTAS EL USO DE TU IMAGEN:</strong></p>
      <ul>
        <li>No podrás participar en clases en vivo</li>
        <li>No podrás asistir a eventos presenciales o virtuales</li>
        <li>No tendrás acceso a sesiones grupales interactivas</li>
        <li>Solo podrás acceder a contenido pregrabado sin interacción</li>
        <li>No podrás recibir certificaciones que requieran verificación de identidad</li>
      </ul>

      <h3>8.4 Grabación de Clases y Almacenamiento</h3>
      <h3>8.4.1 Grabaciones Técnicas</h3>
      <ul>
        <li><strong>TODAS las clases en vivo son grabadas automáticamente</strong></li>
        <li>Propósito principal: Control de calidad y mejora de servicios</li>
        <li>Almacenamiento: Servidores seguros en Italia con respaldo en la UE</li>
        <li>Retención: Hasta 2 años desde la fecha de grabación</li>
      </ul>

      <h3>8.4.2 Procesamiento de Grabaciones</h3>
      <ul>
        <li>Revisión por parte del equipo técnico y pedagógico</li>
        <li>Extracción de fragmentos para material promocional</li>
        <li>Creación de contenido educativo derivado</li>
        <li>Análisis de métricas de participación</li>
      </ul>

      <h3>8.4.3 Seguridad de las Grabaciones</h3>
      <ul>
        <li>Cifrado de extremo a extremo durante la transmisión</li>
        <li>Almacenamiento en servidores con certificación ISO 27001</li>
        <li>Acceso restringido solo a personal autorizado</li>
        <li>Registro de auditoría de todos los accesos</li>
      </ul>

      <h3>8.5 Derechos Específicos sobre Contenido Audiovisual</h3>
      <h3>8.5.1 Derecho de Información Específica</h3>
      <p>Tienes derecho a conocer:</p>
      <ul>
        <li>Qué grabaciones contienen tu imagen</li>
        <li>Dónde han sido publicadas</li>
        <li>Con qué fines se han utilizado</li>
        <li>Quién ha tenido acceso a las mismas</li>
      </ul>

      <h3>8.5.2 Procedimiento para Ejercer Derechos</h3>
      <p>Para ejercer tus derechos sobre tu imagen:</p>
      <ol>
        <li>Envía solicitud escrita a: <a href="mailto:contacto@yarimarodriguez.com">contacto@yarimarodriguez.com</a></li>
        <li>Incluye identificación clara del material específico</li>
        <li>Especifica el derecho que deseas ejercer</li>
        <li>Plazo de respuesta: 30 días hábiles</li>
      </ol>

      <h3>8.5.3 Limitaciones Legales</h3>
      <ul>
        <li>Interés legítimo de la empresa para mantener integridad del contenido educativo</li>
        <li>Derechos de otros participantes en el mismo material</li>
        <li>Requisitos de conservación por obligaciones fiscales</li>
        <li>Material que forme parte de testimonios públicos voluntarios</li>
      </ul>

      <h3>8.6 CONSENTIMIENTO EXPLÍCITO REQUERIDO</h3>
      <p><strong>PARA PARTICIPAR EN NUESTROS SERVICIOS DEBES ACEPTAR EXPLÍCITAMENTE:</strong></p>
      <ul>
        <li>☐ Acepto que mi imagen, voz y semejanza sean grabadas durante las clases y eventos</li>
        <li>☐ Consiento el uso de mi imagen para fines promocionales en redes sociales y marketing</li>
        <li>☐ Entiendo que la negativa a este consentimiento me impide participar en clases y eventos</li>
        <li>☐ Reconozco que puedo revocar mi consentimiento pero esto resultará en exclusión de servicios futuros</li>
        <li>☐ He leído y comprendido la política de uso de imagen y sus consecuencias</li>
      </ul>
      <p>Sin la aceptación de TODOS estos puntos, no podrás acceder a nuestros servicios interactivos.</p>

      <h3>8.7 Bases Legales Específicas</h3>
      <ul>
        <li><strong>Consentimiento (Art. 6.1.a GDPR):</strong> Para uso promocional de imagen</li>
        <li><strong>Interés legítimo (Art. 6.1.f GDPR):</strong> Para grabaciones técnicas y mejora de servicios</li>
        <li><strong>Ejecución contractual (Art. 6.1.b GDPR):</strong> Para prestación del servicio educativo</li>
      </ul>

      <h3>8.8 Contacto para Asuntos de Privacidad</h3>
      <p><strong>Responsable de Protección de Datos:</strong></p>
      <p>Email: <a href="mailto:contacto@yarimarodriguez.com">contacto@yarimarodriguez.com</a><br />
        Horario: Lunes a Viernes, 9:00-17:00 CET</p>
      <p><strong>Para solicitudes urgentes sobre imagen:</strong></p>
      <p>Email prioritario: <a href="mailto:contacto@yarimarodriguez.com">contacto@yarimarodriguez.com</a><br />
        Respuesta garantizada: 72 horas</p>

      <p><strong>RECORDATORIO IMPORTANTE:</strong> El uso de tu imagen con fines promocionales es una condición esencial para la participación en nuestros servicios. Si no estás dispuesto/a a aparecer en redes sociales o material promocional, por favor considera otros proveedores de servicios educativos que se ajusten mejor a tus preferencias de privacidad.</p>

      <h2>9. MODIFICACIONES Y COMUNICACIONES</h2>
      <h3>9.1 Modificaciones de los Términos</h3>
      <ul>
        <li>Nos reservamos el derecho de modificar estos Términos</li>
        <li>Notificación con 30 días de anticipación para cambios sustanciales</li>
        <li>Cambios menores efectivos inmediatamente</li>
        <li>Uso continuado implica aceptación de modificaciones</li>
      </ul>

      <h3>9.2 Comunicaciones</h3>
      <ul>
        <li>Las comunicaciones oficiales se enviarán por correo electrónico</li>
        <li>Debes mantener tu email actualizado</li>
        <li>Se consideran recibidas a las 24 horas del envío</li>
        <li>Idiomas oficiales: Español, Italiano e Inglés</li>
      </ul>

      <h2>10. TERMINACIÓN</h2>
      <h3>10.1 Terminación por el Usuario</h3>
      <p>Puedes cancelar tu cuenta en cualquier momento:</p>
      <ul>
        <li>Mediante solicitud escrita a <a href="mailto:contacto@yarimarodriguez.com">contacto@yarimarodriguez.com</a></li>
        <li>Desde tu panel de control (cuando esté disponible)</li>
        <li>Cumpliendo el período de preaviso según el tipo de servicio</li>
      </ul>

      <h3>10.2 Terminación por la Empresa</h3>
      <p>Podemos terminar tu acceso por:</p>
      <ul>
        <li>Incumplimiento grave o reiterado de estos Términos</li>
        <li>Falta de pago</li>
        <li>Conducta inapropiada o ilegal</li>
        <li>Inactividad prolongada (12 meses)</li>
      </ul>

      <h3>10.3 Efectos de la Terminación</h3>
      <ul>
        <li>Cese inmediato del acceso a los Servicios</li>
        <li>Eliminación de contenido del usuario (con preaviso)</li>
        <li>Obligaciones de pago pendientes permanecen vigentes</li>
        <li>Las cláusulas que por su naturaleza deben sobrevivir, permanecerán vigentes</li>
      </ul>

      <h2>11. RESOLUCIÓN DE DISPUTAS</h2>
      <h3>11.1 Ley Aplicable</h3>
      <p>Estos Términos se rigen por:</p>
      <ul>
        <li>Leyes de Italia para usuarios europeos</li>
        <li>Normativa de protección al consumidor del país del usuario</li>
        <li>Convenios internacionales aplicables</li>
      </ul>

      <h3>11.2 Resolución Amigable</h3>
      <p>Antes de iniciar acciones legales:</p>
      <ul>
        <li>Intento de resolución directa (30 días)</li>
        <li>Mediación voluntaria</li>
        <li>Plataforma ODR de la UE para consumidores europeos: <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer">https://ec.europa.eu/consumers/odr</a></li>
      </ul>

      <h3>11.3 Jurisdicción</h3>
      <p><strong>Para consumidores:</strong></p>
      <ul>
        <li>Tribunales del domicilio del consumidor (UE)</li>
        <li>Tribunales competentes según normativa de protección al consumidor</li>
      </ul>
      <p><strong>Para usuarios comerciales:</strong></p>
      <ul>
        <li>Tribunales de San Benedetto del Tronto, Italia</li>
      </ul>

      <h2>12. DISPOSICIONES PARA USUARIOS DE LATINOAMÉRICA</h2>
      <h3>12.1 Consideraciones Especiales</h3>
      <p>Para usuarios de Latinoamérica:</p>
      <ul>
        <li>Precios pueden mostrarse en USD o moneda local</li>
        <li>Aplicación de normativa local de protección al consumidor</li>
        <li>Métodos de pago regionales disponibles</li>
        <li>Soporte en español</li>
      </ul>

      <h3>12.2 Normativas Específicas por País</h3>
      <p><strong>Argentina:</strong></p>
      <ul>
        <li>Ley de Defensa del Consumidor N° 24.240</li>
        <li>Botón de arrepentimiento disponible</li>
      </ul>
      <p><strong>México:</strong></p>
      <ul>
        <li>Ley Federal de Protección al Consumidor</li>
        <li>PROFECO como autoridad competente</li>
      </ul>
      <p><strong>Colombia:</strong></p>
      <ul>
        <li>Estatuto del Consumidor (Ley 1480 de 2011)</li>
        <li>Superintendencia de Industria y Comercio</li>
      </ul>
      <p><strong>Chile:</strong></p>
      <ul>
        <li>Ley N° 19.496 sobre Protección de los Derechos de los Consumidores</li>
        <li>SERNAC como organismo de protección</li>
      </ul>

      <h2>13. GARANTÍAS Y CONFORMIDAD DEL SERVICIO</h2>
      <h3>13.1 Garantía de Calidad</h3>
      <p>Garantizamos:</p>
      <ul>
        <li>Instructores calificados y experimentados</li>
        <li>Contenido actualizado y de calidad profesional</li>
        <li>Plataforma técnicamente funcional</li>
        <li>Soporte al usuario en horario establecido</li>
      </ul>

      <h3>13.2 Conformidad del Servicio Digital</h3>
      <p>Según la Directiva (UE) 2019/770:</p>
      <ul>
        <li>Funcionalidad conforme a lo descrito</li>
        <li>Actualizaciones de seguridad</li>
        <li>Compatibilidad técnica especificada</li>
        <li>Accesibilidad durante el período contratado</li>
      </ul>

      <h3>13.3 Remedios por No Conformidad</h3>
      <p>En caso de no conformidad:</p>
      <ol>
        <li>Subsanación del problema</li>
        <li>Reducción proporcional del precio</li>
        <li>Resolución del contrato (casos graves)</li>
      </ol>

      <h2>14. FUERZA MAYOR</h2>
      <p>No seremos responsables por incumplimientos causados por:</p>
      <ul>
        <li>Desastres naturales</li>
        <li>Pandemias o emergencias sanitarias</li>
        <li>Guerras o actos terroristas</li>
        <li>Fallos generales de internet o electricidad</li>
        <li>Actos gubernamentales restrictivos</li>
        <li>Otras causas fuera de nuestro control razonable</li>
      </ul>

      <h2>15. DISPOSICIONES FINALES</h2>
      <h3>15.1 Integridad del Acuerdo</h3>
      <p>Estos Términos, junto con la Política de Privacidad, constituyen el acuerdo completo entre las partes.</p>
      <h3>15.2 Divisibilidad</h3>
      <p>Si alguna disposición es declarada inválida, las demás permanecerán vigentes.</p>
      <h3>15.3 No Renuncia</h3>
      <p>La falta de ejercicio de un derecho no constituye renuncia al mismo.</p>
      <h3>15.4 Cesión</h3>
      <p>No puedes ceder estos Términos sin nuestro consentimiento previo por escrito.</p>
      <h3>15.5 Idioma</h3>
      <p>En caso de discrepancia entre versiones, prevalece la versión en español.</p>

      <h2>16. INFORMACIÓN DE CONTACTO</h2>
      <p>Para consultas sobre estos Términos:</p>
      <p>Yarima Rodriguez Valenciano<br />
        Via Vittorio Alfieri 18<br />
        San Benedetto del Tronto (AP), Italia<br />
        Email: <a href="mailto:contacto@yarimarodriguez.com">contacto@yarimarodriguez.com</a></p>
      <p><strong>Horario de atención:</strong><br />
        Lunes a Viernes: 9:00 - 18:00 (CET)<br />
        Sábados: 10:00 - 14:00 (CET)</p>

      <h2>ACEPTACIÓN EXPRESA</h2>
      <p><strong>AL HACER CLIC EN "ACEPTO", REGISTRARTE O USAR LOS SERVICIOS, CONFIRMAS QUE:</strong></p>
      <ol>
        <li>Has leído y comprendido estos Términos.</li>
        <li>Tienes al menos 21 años de edad.</li>
        <li>Aceptas quedar legalmente vinculado por estos Términos.</li>
        <li>Has leído y aceptas la Política de Privacidad.</li>
        <li>Entiendes que cualquier información sobre beneficios del baile o ejercicio NO constituye consejo médico.</li>
        <li>Te comprometes a consultar con profesionales médicos antes de iniciar cualquier programa de ejercicio.</li>
      </ol>
    </LegalPage>
  );
}
